import { render, staticRenderFns } from "./DateIsYesterday.vue?vue&type=template&id=01b9a1e1&scoped=true"
import script from "./DateIsYesterday.vue?vue&type=script&lang=js"
export * from "./DateIsYesterday.vue?vue&type=script&lang=js"
import style0 from "./DateIsYesterday.vue?vue&type=style&index=0&id=01b9a1e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b9a1e1",
  null
  
)

export default component.exports